// 创建文件en/index.js
const Korean = {
    rejected: "거절됨",
    my: "나의",
    today: "오늘",
    this_week: "이번 주",
    this_month: "이번 달",
    last_month: "지난 달",
    this_year: "올해",
    number_of_people: "인원 수",
    amount: "금액",
    enter_username_id_to_search: "사용자 이름 ID를 입력하여 검색",
    team_list: "팀 목록",
    registration_time: "등록 시간",
    selling_face_value: "판매 금액",
    click_for_details: "자세히 보기",
    "agent_login": "에이전트 로그인",
    'SignOut': '계정 로그아웃',
    'Contact us': "문의하기",
    'Download our app': "우리 앱 다운로드",
    'Download it from': "다운로드 URL",
    'About Us': "회사 소개",
    'Gobuy USA was founded in 2012': "Gobuy USA는 2012년에 설립되었습니다.",
    'Customer service': "고객 서비스",
    'frequently asked question': "FAQ",
    'Return and exchange policy': "반품 및 교환 정책",
    'Shipping and distribution': "유통 및 배송",
    'Contact us by email': "이메일로 문의하기",
    'Privacy Policy and Terms of Use': "개인 정보 보호 정책 및 이용 약관",
    'Privacy Policy': "개인 정보 보호 정책",
    'Terms of use': "이용 약관",
    'Upload credentials': "자격 증명 업로드",
    'The withdrawal is being processed': "출금 진행 중",
    'Cause of failure': "실패 이유",
    'Your shopping cart is still empty': "장바구니가 아직 비어 있습니다.",
    'Log in to view the items in your cart': "장바구니에 담긴 상품을 보려면 로그인하세요.",
    'Browse around': "먹다",
    'Account correlation': "계정 관련",
    'Order management': "주문 관리",
    'Payment method': "결제수단",
    'Collection address': "지불 주소",
    Category: "분류",
    "MyCommission": "내 커미션",
    "Gross income": "총 수익",
    "Direct commission": "직접 커미션",
    "Indirect commission": "간접수수료",
    "Transfer to wallet": "지갑으로 이체",
    "Tip: The transfer amount must be greater than 10USDT": "팁: 이체 금액은 10USDT보다 커야 합니다.",
    "transfer": "옮기다",
    "commission": "수수료",
    "Please enter": "입력해주세요",
    'Old Password': "이전 비밀번호",
    'Change password': "비밀번호 변경",
    'Amazon GIFT CARD': "아마존 기프트카드",
    'High Priced Recycling': "고가 재활용",
    'Data': "날짜",
    'congratulations': "축하해요",
    'Obtain': "얻다",
    'ThankYouForParticipating': "참여해주셔서 감사합니다",

    // navbar"",
    Home: "첫 페이지",
    Search: "찾다",
    ShoppingCart: "장바구니",
    Mine: "내 거",

    // 首页
    // 搜索
    EnterSearchContent: "검색 내용을 입력하세요",
    'Recent searches': "최근 검색어",
    'popular searches': "인기 검색어",
    'Please search': "검색하고 싶은 키워드를 입력해주세요",
    'orderSearch': "검색할 주문 또는 제품명을 입력하세요.",

    // 语言
    'Language selection': "언어 선택",

    // menu
    Brand: "상표",
    Collect: "모으다",
    Manage: "관리하다",
    Order: "주문하다",
    Wallet: "지갑",
    BlindBox: "블라인드 박스",
    MenuGiftCard: "기프트 카드",
    // HotSale
    HotSale: "최신 뉴스가 판매 중입니다...",
    // tabs"",
    TodaysOffer: "플랫폼 추천",
    'Phone': "휴대폰",
    'Smart Watch': "스마트 시계",
    'Smart bracelet': "스마트 팔찌",

    // gobuy
    'home.gobuy.title': "놀라움이 당신을 기다리고 있습니다",
    'home.gobuy.periods': "블라인드 박스 라운드",
    'home.gobuy.freeze': "카운트다운에 참여하세요",
    'home.gobuy.drawing': "카운트다운 시작",
    'home.gobuy.buy': "참가하다",
    'home.gobuy.isbuy': "이미 참여했습니다",
    USDT: "USDT",
    'home.gobuy.jackpot': "상금 풀",
    Purse: "지갑",
    Box: "블라인드 박스",
    'GetAPrize': "상품 받기",
    Discount: "할인",
    when: "언제",
    points: "완전한",
    seconds: "두번째",
    // MessageBox
    'MessageBox.Tips': "힌트",
    'MessageBox.Confirm': "확인하다",
    'MessageBox.Cancel': "취소",
    'MessageBox.buy.box': "정말 이 블라인드 박스를 구매하시겠습니까?",
    // Toast
    'succ': "성공",
    'err': "실수",
    'box.succeeds': "구매 성공",
    'box.frozen': "이미 참여했습니다",
    'box.issue': "블라인드박스는 권당 1개만 구매 가능합니다.",

    // 商品列表
    filter: "필터",
    sales: "판매량",
    selfOP: "자체 운영",
    noMore: "더 이상",
    brand: "상표",
    confirm: "확인하다",
    reset: "다시 놓기",
    ComSor: "종합적인 정렬",
    MostPop: "가장 인기있는",
    HighLow: "가격이 높은 것부터 낮은 것 순으로",
    LowHigh: "가격이 낮은 것부터 높은 것 순으로",
    SalVol: "판매량",
    NewArr: "새로운 도착",

    // 购物车
    'cart.cart': "장바구니",
    'cart.edit': "편집하다",
    'cart.done': "마치다",
    'home.cart.voucher': "쿠폰 받기",
    'home.cart.outstock': "품절",
    'home.cart.offshelf': "선반에서 제거됨",
    'Only': "오직",
    'left': "개인",
    'Promotion': "홍보",
    'cart.all': "모두 선택",
    'cart.total': "총",
    'cart.delete': "삭제",
    'cart.checkout': "빌, 제발",

    // 我的
    'Direct': "직접",
    'Indirect': "간접적인",
    'MyOrders': "내 주문",
    'ViewAll': "모두 보기",
    'Unpaid': "결제 대기 중",
    'ToShip': "배송 대기 중",
    'ToReceive': "영수증 대기 중",
    'ToReview': "평가 대기 중",
    // 盲盒
    'MyBlindBox': "블라인드 박스 목록",
    'WaitingDraw': "추첨을 기다리고 있어요",
    'Opened': "개설(수령/반품)",
    // 礼品卡
    'After sale': "판매 후",
    'GiftCard': "재활용 기록",
    'RecycleGiftCard': "기프트 카드 재활용",
    'Verifying': "확인하다",
    'Rebuying': "재구매",
    'Repurchased': "결제 대기 중",
    'Paid': "결제가 완료되었습니다.",
    // 常用工具
    'CommonTools': "일반적인 도구",
    'MyWallet': "내 지갑",
    'VirtualOrders': "가상 주문",
    'Refunds': "환불하다",
    'MyFriends': "내 친구들",
    'ChatList': "채팅 목록",
    'RealNameVerification': "실명인증",
    'MyFavorites': "내 컬렉션",
    'Addresses': "주소 관리",
    'MyReviews': "내 리뷰",
    'BrowsingHistory': "역사 찾아보기",
    'Promotions': "프로모션",
    'StoreManagement': "매장 관리",
    'BecomeASeller': "판매자가 되세요",

    // 订单列表
    'SearchPlaceholder': "검색할 주문상품명을 입력하세요",
    All: "모두",
    OrderNo: "주문 번호",
    items: "조각들",
    ShippingFee: "화물",
    'Refund in Progress': "환불 진행 중",
    'Cancel Order': "주문 취소",
    'Refund': "환불하다",
    'Track Shipping': "물류 확인",
    'Confirm Receipt': "물품 수령을 확인하다",
    'Evaluate': "평가하다",
    'Delete': "삭제",
    'Pay': "지불",
    'MessageBox.delete.order': "정말로 이 주문을 삭제하시겠습니까?",
    'MessageBox.cancel.order': "정말로 이 주문을 취소하시겠습니까?",
    'MessageBox.receive.order': "이 주문이 접수됐나요?",
    // 订单详情
    'Order Details': "주문 세부정보",
    'Pickup Code': "픽업 코드",
    'Complaint': "불평",
    'After-Sales': "판매 후",
    'Gift': "선물",
    'Order Date': "주문 날짜",
    'Used voucher worth': "바우처 사용 금액",
    'CNY': "인민폐",
    'Payment Method': "결제수단",
    'Total Product Amount': "총 상품금액",
    'Shipping Fee': "화물",
    'Amount Paid': "지불금액",
    'Return': "상품을 반품하다",
    // 盲盒列表
    'Pending Draw': "추첨을 기다리는 중",
    'Pending Unboxing': "개봉예정",
    'Unboxed': "이미 켜져 있음",
    'Collected': "받았다",
    'Recycled': "재활용",
    'Unknown': "알려지지 않은",
    'Claim': "받다",
    'Recycle': "자사주 매입",
    'Unbox': "켜다",
    'MessageBox.recycle.box': "이 블라인드 박스를 재활용하시겠습니까?",
    // 盲盒详情
    'Mystery Box Details': "블라인드 박스 세부정보",
    'Unopened': "켜지지 않음",
    'box.opened': "켜지지 않음",
    'Claimed': "받았다",
    'Confirm Claim': "수집 확인",
    'MessageBox.pick.box': "이 블라인드 박스를 추출하시겠습니까?",
    // 盲盒提货
    'Please add address': "주소를 추가해주세요",
    // 礼品卡列表
    'Face Value Total': "총 액면가",
    // 礼品卡详情
    'Gift Card Details': "기프트 카드 세부정보",
    'Card number': "카드번호",
    'Activation code': "활성화 코드",
    'Actual recovery price': "실제 재활용 가격",
    // 礼品卡回收
    'Gift Card Recycling': "기프트 카드 재활용",
    'Confirm Recycling': "재활용 확인",
    'Please enter the card number': "카드번호를 입력해주세요",
    'Please enter the activation code': "활성화 코드를 입력하세요",
    'MessageBox.recycle.gift': "이 기프트 카드를 재활용하시겠습니까?",

    // 我的钱包
    'My Wallet': "내 지갑",
    'Available Balance': "사용 가능한 잔액",
    'Frozen Funds': "자금 동결",
    'Recharge': "충전하다",
    "can": "가능",
    'Withdraw': "현금 인출",
    'Withdrawal Accounts': "계좌 출금",
    // 充值
    'Recharge Details': "충전 세부정보",
    'Recharge Order No.': "충전 주문 번호",
    'Recharge Amount': "충전금액",
    'Creation Time': "생성 시간",
    'MessageBox.recharge.pop': "충전금액을 입력해주세요",
    // 付款
    'payment': "지불",
    'Order submitted successfully, please select payment method': "주문이 성공적으로 제출되었습니다. 결제 수단을 선택하세요.",
    'Rechargeable card': "충전식 카드",
    'Please enter a hash': "해시를 입력하세요.",
    'Immediate payment': "지금 결제",
    'Wait for the file to load': "파일이 로드될 때까지 기다려 주십시오.",
    // 提现
    'Withdrawal Details': "출금내역",
    'Withdrawal Amount': "출금금액",
    'Application Time': "신청시기",
    'New Application': "새로운 애플리케이션",
    'Payment Password': "결제 비밀번호",
    'New Payment Password': "새로운 결제 비밀번호",
    'Recipient Information': "수취인 정보",
    'Submit': "제출하다",
    'Add Recipient Account First': "먼저 결제 계좌를 추가하세요.",
    'Please bind your mobile phone or email first': "먼저 휴대폰이나 이메일을 묶어주세요",
    // 设置
    'Account Settings': "계정 설정",
    'Change Login Password': "로그인 비밀번호 변경",
    'Change Payment Password': "결제 비밀번호 변경",
    'Log Out': "로그아웃",
    'Mobile': "휴대폰",
    'Verification Code': "인증코드",
    'Email': "우편",
    'New Password': "새 비밀번호",
    'Confirm Password': "비밀번호 확인",
    'Modify': "개정하다",
    'Bind': "제본",
    ' Mobile': "휴대폰",
    ' Email': "우편",
    // 资金详情
    'Fund Details': "자금 세부정보",
    'Withdrawal Account': "계좌 출금",
    'Account Type': "계좌 유형",
    'USDT Address (TRC20)': "USDT 주소(TRC20)",
    'Edit': "편집하다",
    'Delete': "삭제",
    'Add New': "새 계정 추가",
    'MessageBox.delete.bank': "이 출금 계좌를 삭제하시겠습니까?",
    // 登录
    'Login': "로그인",
    'Sign Up': "등록하다",
    'Normal Login': "일반 로그인",
    'Username / Email / Phone Number': "사용자 이름/이메일",
    'Enter Phone Number': "휴대폰번호를 입력해주세요",
    'Enter Email': "이메일을 입력해주세요",
    'Enter SMS Code': "SMS 인증번호를 입력해주세요",
    'Enter Password': "비밀번호를 입력해주세요",
    "enter_login_password_for_verification": "로그인 비밀번호를 입력하여 인증해주세요",
    'Forgot Password': "비밀번호를 잊어버려",
    'Third-party Login': "제3자 로그인",
    'Please complete the form': "양식을 작성해주세요",
    'WeChat': "위챗",
    'Weibo': "웨이보",
    'QQ': "QQ",
    'phone login': "모바일 로그인",
    'Login Expired': "로그인이 만료되었습니다",
    'Please enter your phone number first': "먼저 휴대폰 번호를 입력해주세요",
    'Please enter your username/email/phone number': "사용자 이름/이메일을 입력하세요.",
    'Please enter your password': "비밀번호를 입력해주세요",
    'Password must be at least 6 characters': "비밀번호는 6자 이상이어야 합니다.",
    'Please enter an 11-digit phone number': "휴대전화번호 11자리를 입력해주세요.",
    'Please wait for the file to finish loading': "파일이 로드될 때까지 기다려 주십시오.",
    'send': "보내다",
    'signUpTips': "귀하의 개인 데이터는 웹사이트 전체에서 귀하의 경험을 지원하고, 귀하의 계정에 대한 액세스를 관리하며, 당사의 개인정보 보호정책에 설명된 기타 목적을 위해 사용됩니다.",

    // 注册
    'Sign Up': "등록하다",
    'Referrer': "추천인",
    'Invitation code': "초대코드",
    'Invite friends': "친구 초대",
    'Username': "사용자 이름",
    'Full Name': "실명",
    'Set Password': "비밀번호 설정",
    'Confirm Password': "비밀번호 확인",
    'Phone Number': "전화 번호",
    'Email': "이메일",
    'Username: 3-25 chars, letters & numbers': "사용자 이름: 3~25자, 문자, 숫자",
    '6-20 digits/letters/symbols': "6~20자리 숫자/문자/기호",
    'By clicking sign up, you agree to': "등록을 클릭하면 동의하는 것으로 간주됩니다.",
    'User Agreement': "사용자 계약",
    'Please check the user agreement': "이용약관을 확인해주세요",
    'Please enter a username with 3-25 characters': "3~25자의 사용자 이름을 입력하세요.",
    'Enter SMS Verification Code': "SMS 인증번호를 입력해주세요",
    'Please enter your phone number': "휴대폰 번호를 입력해주세요",
    'Please enter the verification code': "인증번호를 입력해주세요",
    'Please enter a 6-digit verification code': "인증번호 6자리를 입력해주세요",
    'Please enter a password with 6-20 characters': "6~20자의 비밀번호를 입력하세요.",
    'Please enter the confirm password': "확인 비밀번호를 입력해주세요",
    'The confirm password does not match the entered password': "확인 비밀번호가 입력한 비밀번호와 일치하지 않습니다.",

    // 密码恢复
    'Password Recovery': "비밀번호 복구",
    'Forgot Password': "비밀번호를 잊어버려",
    'Forget.email.tips': "귀하의 계정이 아직 이메일 번호와 연결되지 않은 경우 플랫폼 관리자에게 문의하여 비밀번호를 복구하십시오.",

    // 通知
    'Notification Message': "알림 메시지",
    'Direct Message': "사신",
    'System Message': "시스템 메시지",
    'Leave a Message': "메시지",

    // 配送地址
    'Delivery Address': "배송 주소",
    'The store is no longer valid, please edit the delivery address again': "이 상점은 더 이상 유효하지 않습니다. 배송 주소를 다시 편집하십시오.",
    'Default address': "기본 주소",
    'Add address': "주소 추가",
    'Edit address': "주소 수정",
    'MessageBox.delete.address': "이 주소를 삭제하시겠습니까?",
    'name': "이름",
    'phone': "전화 번호",
    'district': "구역",
    'address': "주소",
    'default address': "기본 주소",
    'save and use': "저장하고 사용하세요",
    'save': "구하다",
    'Please select a region': "지역을 선택해주세요",
    'Please fill in the recipient name': "수취인 이름을 입력해주세요",
    'Name must be 2-15 characters': "이름은 2~15자여야 합니다.",
    'Please fill in the mobile phone number': "휴대폰번호를 입력해주세요",
    'Please select your location': "귀하의 위치를 ​​선택해 주세요",
    'Please fill in the detailed address': "자세한 주소를 입력해주세요",

    // 浏览历史
    'Browsing History': "역사 찾아보기",
    'Clear browsing history': "인터넷 사용 기록 삭제",

    // 推广会员
    'Promotion member': "회원 승격",
    "“PromotionPoster”": "홍보 포스터",
    "MemberName": "회원 이름",
    "MyAssets": "내 자산",
    "DistributedAmount": "분배금액",
    "NumberOfDistributedProducts": "제품 수량 할당",
    "DistributedProductAmount": "분배금액",
    "MyTeam": "내 팀",
    "LevelOneMembers": "일등회원",
    "LevelTwoMembers": "두 번째 레벨 회원",
    "PromotionPoster": "홍보 포스터",
    "PromotionMembers": "회원 승격",
    "PromotionPerformance": "프로모션 성과",
    "ViewPromotionLink": "프로모션 링크를 보려면 클릭하세요.",
    "PromoteViaWeChatQRCode": "WeChat QR 코드를 통해 홍보",
    "Copy": "복사",
    "BrowserNotSupportedCopyManually": "귀하의 브라우저는 직접 복사를 지원하지 않습니다. 수동으로 복사하십시오.",
    "GiftCardRecoveryTotal": "재활용된 기프트 카드의 총 개수",
    "TodaysGiftCardRecoveryCount": "오늘의 기프트카드 재활용 횟수",
    "RegistrationDate": "등록일",
    "LastLogin": "마지막 로그인",
    "Promotion Commission": "프로모션 커미션",

    // userinfo 个人信息
    "Personal Info": "개인정보",
    "Nickname": "닉네임",
    "Birthdate": "생일",
    "Save": "구하다",
    "CropImage": "사진 자르기",
    "UseImage": "사진 사용",

    // goodsDetail 商品详情
    "Off": "할인",
    "Sold": "판매된",
    "Product": "제품",
    "Comment": "논평",
    "Details": "세부",
    "ReportViolation": "보고서",
    "Cart": "장바구니",
    "ChatMessages": "채팅 메시지",
    "MyShop": "내 가게",
    "MerchantLogin": "판매자 로그인",
    "Share": "공유하다",
    "ShareTo": "공유 대상",
    "WeChat": "위챗",
    "Copy": "복사",
    "Poster": "포스터",
    "BrowserNotSupportedCopyManually": "귀하의 브라우저는 직접 복사를 지원하지 않습니다. 수동으로 복사하십시오.",
    "Follow": "집중하다",
    "Unfollow": "언팔로우",
    "PleaseSelectQuantityAndCategory": "수량과 카테고리를 선택해주세요.",
    "SelectedWithQuantity1": "{사양}, 수량 {번호}개를 선택했습니다.",
    "SelectedQuantity1": "수량 {number}개를 선택했습니다.",
    "SelectedWithQuantity2": "{사양}, 수량 {번호}개를 선택했습니다.",
    "Add to cart": "장바구니에 추가",
    "Buy now": "지금 구매하세요",
    "Stock": "재고 있음",
    "Pieces": "조각들",
    "Quantity": "수량",
    "All": "모두",
    "Good": "좋은 리뷰",
    "Medium": "중립 등급",
    "Bad": "나쁜 리뷰",
    // 评论
    "Product review": "제품 리뷰",
    "anonymous": "익명의",
    "noReviewInfo": "제공된 댓글 정보가 없습니다.",
    "Shop Owners Response": "가게 주인이 대답하다",
    "This product has no current reviews": "현재 이 제품에 대한 리뷰가 없습니다.",
    "Product details": "제품 세부정보",
    "shop": "가게",
    "customerService": "고객 서비스",
    "shoppingCart": "장바구니",
    "addToCart": "장바구니에 추가",
    "buyNow": "지금 구매하세요",
    "outOfStock": "선택하신 상품은 현재 품절입니다. 죄송합니다!",
    "notAvailable": "선택한 제품은 더 이상 구매할 수 없습니다. 죄송합니다!",
    "Store order message": "매장주문 소식",
    "Confirm the order": "주문 확인",
    "productAmount": "상품금액",
    "discount": "할인",
    "shippingFee": "화물",
    "subtotal": "매장 소계",
    "Submit an order": "주문 제출",
    // 退货
    "refundAdd": "환불 추가",
    "back": "반품",
    "refundDescription": "환불 지침:",
    "proofOfRefund": "환불쿠폰",
    "use": "사용",
}
export default Korean
